import { render, staticRenderFns } from "./TicketStatusTag.vue?vue&type=template&id=6158d7c6"
import script from "./TicketStatusTag.vue?vue&type=script&lang=js"
export * from "./TicketStatusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports